import React from 'react';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, author, cata, brief}) => (
<div>
    <Link to={`/book/detail/${novel_id}`}>
        <div>
            <em style={{width:'160px',height:'206px',display:'block'}}>
                <img alt='' src={pic} style={{height: '100%',width: '100%'}}/>
            </em>
            <div style={{maxWidth:'160px',fontSize: '16px',lineHeight: '22px',color: '#333333',marginTop:'10px',textAlign:'center'}}>
                <LinesEllipsis maxLine={1} text={name}/>
            </div>
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_11.js